import { FC } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import formatPrice from "@/core/helpers/formatPrice";
import useAppSelector from "@/core/helpers/useAppSelector";
import { BankCardIcon, CashIcon, Info2Icon, Vehicle2Icon } from "@/shared/icons";
import { BaseIconProps } from "@/shared/icons/BaseIcon";
import { Button } from "@/shared/ui";
import DeviceTabsWrapper from "@/shared/widgets/DeviceTabsWrapper";
import { Tab } from "@/domains/transportWarehouse/constants/tab";
import { playerInfoSelector } from "@/domains/player/slice";
import { useTransportWarehouseStore } from "@/domains/transportWarehouse/store";

const icon: Record<Tab, FC<BaseIconProps>> = {
  [Tab.Info]: Info2Icon,
  [Tab.Transport]: Vehicle2Icon,
};

export default function TransportWarehouseTabsContainer() {
  const playerInfo = useAppSelector(playerInfoSelector);
  const { t } = useTranslation("transportWarehouse");
  const currTab = useTransportWarehouseStore((state) => state.currTab);
  const tabs = useTransportWarehouseStore((state) => state.tabs);
  const changeTab = useTransportWarehouseStore((state) => state.changeTab);

  return (
    <DeviceTabsWrapper
      logoSrc="/svg/tablet/my-transport.svg"
      title={t("transportWarehouse.myTransport")}
      description={t("transportWarehouse.transportWarehouse")}
      className="p-0 w-56"
      isBackground
    >
      {tabs.map((item) => (
        <Button
          key={item}
          variant={item === currTab ? "solid-gradient" : "soft"}
          color={item === currTab ? "accent" : "gray"}
          className={clsx(
            "h-[2.75rem] px-3.5 flex justify-start items-center gap-2.5 hover:brightness-110",
          )}
          onClick={() => changeTab(item)}
        >
          {icon[item]({
            size: 16,
            className: item === currTab ? "text-white" : "text-white/50",
          })}
          {t(`transportWarehouse.tabs.${Tab[item]}`)}
        </Button>
      ))}
      <div className="mt-auto flex flex-col gap-2.5">
        <div className="flex items-center gap-3.5">
          <CashIcon size={20} className="text-accent-muted" />
          <div className="flex flex-col items-start">
            <div className="text-15 font-medium text-accent-muted">
              {t("transportWarehouse.cash")}
            </div>
            <div className="text-15 font-bold">
              {formatPrice(playerInfo?.character?.money?.balance || 0)} ₽
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3.5">
          <BankCardIcon size={20} className="text-accent-muted" />
          <div className="flex flex-col items-start">
            <div className="text-15 font-medium text-accent-muted">
              {t("transportWarehouse.bankCard")}
            </div>
            <div className="text-15 font-bold">
              {formatPrice(playerInfo?.character?.money?.bank || 0)} ₽
            </div>
          </div>
        </div>
      </div>
    </DeviceTabsWrapper>
  );
}
